import { createSlice } from "@reduxjs/toolkit";
import { fetchProductByID, fetchProducts, fetchProductsByCategory } from "../../services/productService";

const productSlice = createSlice({
    name : 'product',
    initialState : {
        products : [],
        loader : false,
        status : '',
        product: null,
        productByCat: [],
       pagination: {
        current_page: 1,
        limit: 9,
        total_items: 0,
        total_pages: 0
        }
    },
    reducers : {},
    extraReducers : (builder) => {
        builder
        .addCase(fetchProducts.pending, (state) => {
            state.loader = true
        })
        .addCase(fetchProducts.rejected, (state) => {
            state.loader = false;
            state.status = 'error';
        })
        .addCase(fetchProducts.fulfilled, (state, action) => {
            state.loader = false;
            state.products = action.payload.data;
            state.pagination = action.payload.pagination
        })
        .addCase(fetchProductByID.pending, (state) => {
            state.loader = true
        })
        .addCase(fetchProductByID.rejected, (state) => {
            state.loader = false;
            state.status = 'error';
        })
        .addCase(fetchProductByID.fulfilled, (state, action) => {
            state.loader = false;
            state.product = action.payload;
        })
        .addCase(fetchProductsByCategory.pending, (state) => {
           // state.loader = true
        })
        .addCase(fetchProductsByCategory.fulfilled, (state, action) => {
            state.loader = false;
            state.productByCat = action.payload;
        })
        .addCase(fetchProductsByCategory.rejected, (state) => {
            state.loader = false;
            state.status = 'error';
        })
    }
})
export default productSlice.reducer
export const {searchProducts, incrementQuantity} = productSlice.actions